import { render, staticRenderFns } from "./PrintMeals.vue?vue&type=template&id=004196f7&scoped=true&"
import script from "./PrintMeals.vue?vue&type=script&lang=js&"
export * from "./PrintMeals.vue?vue&type=script&lang=js&"
import style0 from "./PrintMeals.vue?vue&type=style&index=0&id=004196f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004196f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
